import { render } from "./gorinsyoPage.vue?vue&type=template&id=46fcffed"
import script from "./gorinsyoPage.vue?vue&type=script&lang=js"
export * from "./gorinsyoPage.vue?vue&type=script&lang=js"

import "./gorinsyoPage.vue?vue&type=style&index=0&id=46fcffed&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__